import { ContractInvoiceType } from "@boark/shared/types/contract";
import { ContractWithCounterParty } from "@boark/shared/types/contract-with-counter-party";

/** Recurring amount normalized to an annual total (for charts and comparisons). */
export function annualizedContractCost(
  contract: Pick<ContractWithCounterParty, "cost" | "invoiceType">,
): number {
  const cost = contract.cost;
  if (cost === undefined || cost === null || Number.isNaN(Number(cost))) {
    return 0;
  }
  const n = Number(cost);
  switch (contract.invoiceType) {
    case ContractInvoiceType.MONTHLY:
      return n * 12;
    case ContractInvoiceType.QUARTERLY:
      return n * 4;
    case ContractInvoiceType.SEMI_ANNUALLY:
      return n * 2;
    case ContractInvoiceType.ANNUALLY:
      return n;
    default:
      return n;
  }
}
